type ModelContext = {
  registerTool?: (tool: {
    name: string;
    description: string;
    inputSchema: unknown;
    execute: (input: any) => Promise<any> | any;
  }) => { unregister?: () => void } | void;
  provideContext?: (ctx: { tools: Array<any> }) => void;
};

declare global {
  interface Navigator {
    modelContext?: ModelContext;
  }
}

export function registerWebmcpTools() {
  const mc = navigator.modelContext;
  if (!mc?.registerTool && !mc?.provideContext) return;

  const unregisters: Array<() => void> = [];

  const tools: Array<any> = [];

  const reg = (tool: any) => {
    tools.push(tool);
    if (mc.registerTool) {
      const r = mc.registerTool(tool) as any;
      if (r?.unregister) unregisters.push(() => r.unregister());
    }
  };

  reg({
    name: 'burok.navigate',
    description: 'Naviguer vers une route interne du site Burok.',
    inputSchema: {
      type: 'object',
      properties: { path: { type: 'string', description: 'Chemin interne, ex: /privacy ou /en/support' } },
      required: ['path'],
      additionalProperties: false,
    },
    execute: ({ path }: { path: string }) => {
      if (typeof path !== 'string' || !path.startsWith('/')) throw new Error('path invalide');
      window.location.assign(path);
      return { ok: true };
    },
  });

  reg({
    name: 'burok.setLanguage',
    description: 'Définir la langue du site (fr/en) en naviguant vers la version correspondante.',
    inputSchema: {
      type: 'object',
      properties: { language: { type: 'string', enum: ['fr', 'en'] } },
      required: ['language'],
      additionalProperties: false,
    },
    execute: ({ language }: { language: 'fr' | 'en' }) => {
      const current = window.location.pathname;
      const isEn = current === '/en' || current.startsWith('/en/');
      const next =
        language === 'en'
          ? isEn
            ? current
            : current === '/'
              ? '/en'
              : `/en${current}`
          : isEn
            ? current === '/en'
              ? '/'
              : current.replace(/^\/en/, '')
            : current;
      window.location.assign(next || '/');
      return { ok: true, path: next || '/' };
    },
  });

  reg({
    name: 'burok.listRoutes',
    description: 'Lister les routes principales disponibles sur burok.app.',
    inputSchema: { type: 'object', properties: {}, additionalProperties: false },
    execute: () => ({
      routes: ['/', '/en', '/cgu', '/privacy', '/support', '/data/delete', '/en/cgu', '/en/privacy', '/en/support', '/en/data/delete'],
    }),
  });

  const controller = new AbortController();

  // Some environments expose provideContext() instead of registerTool().
  if (mc.provideContext) {
    mc.provideContext({ tools });
  }

  window.addEventListener(
    'beforeunload',
    () => {
      controller.abort();
      unregisters.forEach((u) => u());
    },
    { once: true },
  );
}

